import { readCssPixel } from "../../../../utils/readCssPixel";

export type LightboxRect = {
    top: number;
    left: number;
    width: number;
    height: number;
};

/**
 * Bottom inset the shell writes onto the page. Native chat uses this for the
 * composer coverage, which already includes the home indicator.
 */
export function readBottomSafeArea(): number {
    return readCssPixel(
        getComputedStyle(document.documentElement).getPropertyValue(
            "--safe-area-inset-bottom",
        ),
    );
}

export function getTargetRect({
    naturalWidth,
    naturalHeight,
    padding,
    viewportWidth,
    viewportHeight,
    bottomInset,
}: {
    naturalWidth: number;
    naturalHeight: number;
    padding: number;
    viewportWidth: number;
    viewportHeight: number;
    bottomInset: number;
}): LightboxRect {
    const inset = Math.max(0, bottomInset);
    const availableHeight = Math.max(0, viewportHeight - inset);
    const maxWidth = Math.max(0, viewportWidth - padding * 2);
    const maxHeight = Math.max(0, availableHeight - padding * 2);
    const aspect =
        naturalWidth > 0 && naturalHeight > 0
            ? naturalWidth / naturalHeight
            : maxWidth / Math.max(maxHeight, 1);

    let width = maxWidth;
    let height = width / aspect;

    if (height > maxHeight) {
        height = maxHeight;
        width = height * aspect;
    }

    return {
        width,
        height,
        left: (viewportWidth - width) / 2,
        top: (availableHeight - height) / 2,
    };
}
